function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.727 13.61c0 .477-.14.92-.364 1.309l-7.176-7.693 7.098-5.95c.276.42.442.913.442 1.446V13.61zM11.364 8.623L21.24.343A2.901 2.901 0 0 0 19.886 0H2.841c-.493 0-.95.13-1.353.343l9.876 8.28zm2.753-.5l-2.286 1.917a.728.728 0 0 1-.467.167.728.728 0 0 1-.468-.167L8.61 8.122l-7.266 7.791c.435.262.946.419 1.498.419h17.045c.552 0 1.063-.157 1.499-.419l-7.268-7.79zM.443 1.275A2.62 2.62 0 0 0 0 2.722V13.61c0 .477.14.92.365 1.309L7.54 7.225.443 1.276z",
  fill: "#FFF",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-email.fb4a81b9.svg";
export { SvgComponent as ReactComponent };